import React, { useState, useEffect } from "react";

import { filterInsuranceGi } from "api/prequalify";
import AddIcon from "@mui/icons-material/Add";
import { StyledQuestion } from "../styles";
import { isEmpty } from "lodash";

import { FunctionalButton } from "components/functionalButton";
import { AddFinancialPopup } from "../../../../components/addFinancialPopup";

import InsuranceTypeAndNamePick from "./insuranceTypeAndNamePick";

import { saveSingleFinancial } from "api/profile";
import { useSelector } from "react-redux";
import { getECQSWizardContextSelector } from "data/selectors/ecqs";

export const InsurancePickList = ({
  prequalifyData,
  setPrequalifyData,
  setIsLastPanel,
  setPreviousStepPanel,
  handleNext,
  popupTitle,
  setRerender,
  insuranceType,
  institutionId,
  esubId,
}) => {
  setIsLastPanel(true);
  setPreviousStepPanel(1);

  const wizardContext = useSelector(getECQSWizardContextSelector);
  const isEsub = wizardContext === "e-sub";
  const finalEsubId = esubId || prequalifyData?.esubId || null;

  const [openPopup, setOpenPopup] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [object, setObject] = useState(null);

  useEffect(() => {
    filterInsuranceGi("", { institution_id: institutionId })
      .then((data) => setFilteredData(data))
      .catch(() => {});

    if (isEmpty(prequalifyData?.insuranceList?.order)) {
      setObject(getInitialInsurance());
    } else {
      setObject(prequalifyData?.insuranceList);
    }
  }, []);

  useEffect(() => {
    setPrequalifyData("insuranceList", object);
  }, [object]);

  const getInitialInsurance = () => ({
    order: [0],
    state: {
      0: { type: null, data: {} },
    },
  });

  const addOtherInsuranceType = () => {
    const max = Math.max(...object?.order);
    const nextIdx = max + 1;
    object.order = [...object.order, nextIdx];
    object.state[nextIdx] = getInitialInsurance().state[0];
    setObject({ ...object });
  };

  const removeInsuranceType = (idx) => {
    const temp = { ...object };
    temp.order = temp.order.filter((o) => o !== idx);
    delete temp.state[idx];
    setObject(isEmpty(temp.order) ? getInitialInsurance() : temp);
  };

  return (
    <>
      <StyledQuestion marginBottom="32px">
        {isEsub
          ? "Which Insurance Companies Does the Contractor Currently Work With?"
          : "Which Insurance Companies do you currently use?"}
      </StyledQuestion>

      {object?.order?.map((idx) => (
        <InsuranceTypeAndNamePick
          key={idx}
          insuranceType={insuranceType}
          index={idx}
          object={object}
          setObject={setObject}
          filteredData={filteredData}
          removeInsuranceType={removeInsuranceType}
          isEsub={isEsub}
          esubId={finalEsubId}
        />
      ))}

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {object?.order?.length < insuranceType.length && (
          <div style={{ display: "flex", alignItems: "center", cursor: "pointer", color: "#FF6D1D" }} onClick={addOtherInsuranceType}>
            <AddIcon /> Insurance Type
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", cursor: "pointer", color: "#FF6D1D" }} onClick={() => setOpenPopup(true)}>
          <AddIcon /> New Insurance Company
        </div>
      </div>

      <FunctionalButton
        buttonTitle="Next"
        handleButton={handleNext}
        width="200px"
        marginRight="auto"
        marginLeft="auto"
        marginTop="16px"
      />

      <AddFinancialPopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        handleButtonFunc={(props) => {
          const payload = institutionId ? { ...props, institution_id: institutionId } : props;
          saveSingleFinancial(payload, () => filterInsuranceGi("", { institution_id: institutionId }).then(setFilteredData), () => {});
        }}
        data={{ type: "insurance" }}
        popupTitle={popupTitle}
      />
    </>
  );
};

export default InsurancePickList;
